module.exports = __webpack_public_path__ + "img/logo.6887b97f.png";